Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-product-list-on-demand');

    if ($wrapper.length < 1)
        return;

    var $container = $('.on-demand-container', $wrapper);
    var $productLists = $('.product-list-on-demand', $wrapper);
    var $selector = $('.select-wrapper'), $selectorItem = $('option', $selector);
    var $code = $('option:selected', $selector).val();
    var $selected = $('.product-list-on-demand[data-code="' + $code + '"]');

    var $configuration, configurations = [], currentitemid = 0;

    if (LhApp.Context.Item.Id !== undefined && LhApp.Context.Item.Id > 0)
        currentitemid = LhApp.Context.Item.Id;

    initSlider($selected);

    $selector.on('change', function (e) {
        
        var $this = $(this);
        var $code = $('option:selected', $this).val();
        var $selected = $('.product-list-on-demand[data-code="' + $code + '"]');

        if ($selected.hasClass('hidden')) {
            $productLists.addClass('hidden');
            $selected.removeClass('hidden');
        }

        if ($selected.find('.x-product-list').length == 0) {
            initLazyProductList($selected);
        }
    });

    function initLazyProductList(wrpr) {

        $container.addClass('x-loading');

        var $this = $(wrpr);
        wrpr.model = null;

        var lazyLoadPrices = $('.list-lazy-load-prices', wrpr).text().toLowerCase().trim() === "true";
        //check if current user has custom prices
        var currentUser = Vendd.User && Vendd.User.GetClientModel();
        var customPrices = currentUser && currentUser.HasCustomPrices;

        var configuration = {
            configCode: $this.data("code"),
            templateCode: $this.data("template"),
            entityCode: $this.data("entity"),
            itemId: currentitemid,
            refreshInterval: $this.data("refresh-interval") === undefined ? 0 : parseInt($this.data("refresh-interval")),
            nodeId: $this.data("nodeid"),
            nodePath: $this.data("nodepath"),
        };

        if ($('.x-product-details').length > 0 && $('.x-product-details').data('selected-color-id') > 0 && $this.data("photodimensiondependent")) {
            configuration.photoDimensionId = $('.x-product-details').data('selected-color-id');
        }

        wrpr.loading = function loading(loading) {
            if (loading) {
                $this.addClass('x-loading');
            } else {
                $this.removeClass('x-loading');
            }
        };

        wrpr.update = function update() {
            wrpr.loading(true);

            var partial = $this.data('partial');
            var html = Vendd.Handlebars.parse(partial, wrpr.model);
            wrpr.bind(html);

            var connectedList = $(wrpr).data('list');
            if (connectedList !== undefined) {
                $('.num-of-products[data-list-count="' + connectedList + '"]').html(wrpr.model.ItemsCountText);
            }
            Vendd.MessageBus.publish(wrpr, new Vendd.Widget.Messages.BindControl($(wrpr)));

            if (wrpr.model.Items.length > 0) {
                if (wrpr.model.HasQuickBuy) {
                    Vendd.Quickbuy.addToQuickbuyList(wrpr.model.Items[0], true);
                }
            }

            if (lazyLoadPrices || customPrices) {
                var items = [];
                $('.x-product-box[data-variantid]', wrpr).each(function (i, el) {
                    items.push(parseInt($(el).attr('data-variantid')));
                });

                var obj = {
                    itemIds: items,
                    fetchPrices: true,
                    fetchAvailabilities: true,
                    fetchStock: true
                };
                Vendd.MessageBus.publishAsync(wrpr, new Vendd.ScrollList.Messages.GetClientProductListData(obj));
                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrpr, wrpr.onGetClientProductListDataSuccess);
                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataFailure, wrpr, wrpr.onGetClientProductListDataFailure);
            }

            wrpr.loading(false);
        };

        wrpr.bind = function bind(html) {
            $this.html(html);
            $('.x-product-list', $this).addClass('swiper');
            formatPrices($this);
            initSlider($this);          
        };

        wrpr.getConfiguration = function () {
            return configuration;
        };

        wrpr.setModel = function (model) {
            wrpr.model = model;
        };

        wrpr.onGetClientProductListDataSuccess = function (envelope) {
            var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
            ReplacePrices(result);
            ReplaceAvailabilities(result);
        };

        wrpr.onGetClientProductListDataFailure = function (envelope) {
            //console.log(envelope.message.data);
        };

        function removeConfiguration(innerwrapper, config) {

            if ($this.length > 0) {
                $this = $this.slice(1);
            }

            if (configurations.length > 0) {
                var configIndex = configurations.indexOf(config);
                configurations.splice(configIndex, 1);
            }
        };

        Vendd.MessageBus.publishAsync(wrpr, new Vendd.LazyProductList.Messages.GetLazyProductList(configuration));

        Vendd.MessageBus.subscribe(Vendd.LazyProductList.Messages.LazyProductListSuccess, wrpr, function (envelope) {
            var sender = envelope.message.data.sender;
            if (wrpr && sender && wrpr == sender) {
                var model = envelope.message.data.model;
                wrpr.setModel(model);
                wrpr.update();
                if ($(wrpr).data("has-filter") != undefined) {
                    var connectedList = $(wrpr).data('list');
                    if (connectedList !== undefined) {
                        var $connectedFilter = $('.js-filters-wrapper[data-list="' + connectedList + '"]').first();
                        if ($connectedFilter.length > 0) {
                            Vendd.MessageBus.publishAsync($connectedFilter.get(0), new Vendd.FilterProduct.Messages.Changed(model.Filters.Filters));
                        }
                    }
                }
            }

            $container.removeClass('x-loading');

        });

        var ReplacePrices = function (obj) {
            $('.x-product-box[data-variantid]', wrapper).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });

                if (itemData.length === 0) return;

                var prices = itemData[0].Prices.Price;
                var points = itemData[0].Prices.Points;
                var pointsGain = itemData[0].Prices.PointsGain;
                var countdownPrices = itemData[0].CountDownProperties;

                // hide all
                $('.discount-container', el).addClass('hide');
                $('.deleted-price-container', el).addClass('hide');
                $('.current-price-container', el).addClass('hide');
                $('.current-points-price-container', el).addClass('hide');
                $('.current-points-gain-container', el).addClass('hide');

                if (prices) {
                    if (prices.Discount) {
                        $('.tag.discount', el).text('-' + prices.Discount + '%');
                    }
                    if (prices.DiscountValue) {
                        $('.discount-container', el).removeClass('hide');
                        $('.discount-value', el).text(decodeEntities(prices.DiscountValue));
                    }
                    if (prices.DeletedPrice) {
                        $('.deleted-price-container', el).removeClass('hide');
                        $('.deleted-price', el).text(decodeEntities(prices.DeletedPrice));
                    } else if (countdownPrices) {
                        $('.deleted-price-container', el).removeClass('hide');
                        $('.deleted-price', el).text(decodeEntities(prices.CurrentPrice));
                    }

                    var displayedPrice = decodeEntities(prices.CurrentPrice);
                    if (countdownPrices && countdownPrices.Price) {
                        displayedPrice = countdownPrices.Price;
                    }
                    var $currentPrice = $('.current-price', el);
                    if ($enableFormatPrices) {
                        $currentPrice.html(formatPrice(displayedPrice));
                        $currentPrice.addClass('price-formatted');
                    } else {
                        $currentPrice.text(displayedPrice);
                    }
                    $('.current-price-container', el).removeClass('hide');
                }

                if (points) {
                    $('.current-point-price-container', el).removeClass('hide');
                    $('.current-point-price-container .points-price', el).text(points.PointsPrice);
                }

                if (pointsGain) {
                    $('.current-point-price-container', el).removeClass('hide');
                    $('.current-point-price-container .points-gain', el).text(pointsGain.TotalPointsGain);
                }

            });
        };

        var ReplaceAvailabilities = function (obj) {
            $('.x-product-box[data-variantid]', wrpr).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });
                if (itemData.length > 0) {
                    var availability = itemData[0].Availability.AvailabilityData;
                    var cartEnabled = availability.CanBuy === true;
                    $('.availability', $(this)).addClass("availability-" + availability.AvailabilityActionId).text(availability.Name).parent('.availability-container').removeClass('hide');
                    if (cartEnabled) {
                        $('.buttons .add-to-cart', $(this)).removeClass('x-disabled');
                        $('.buttons .add-to-cart button', $(this)).removeAttr('disabled', 'disabled');
                    }
                }
            });
        };
    };

    function initSlider(wrapper) {
        var onDemandSliders = [];

        function createOnDemandSlider(element) {
            return new Swiper(element, {
                slidesPerView: 2,
                watchSlidesProgress: true,
                keyboard: { enabled: true },
                spaceBetween: 10,
                speed: 1000,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1200: { slidesPerView: 5 },
                    960: { slidesPerView: 4 },
                    768: { slidesPerView: 3 },
                    480: { slidesPerView: 2 }
                }
            });
        }

        function initializeSliders() {
            var ww = $(window).outerWidth();
            var mobile = (ww < 960);

            $(wrapper).find('.x-product-list').each(function (index, element) {
                if (!$(element).hasClass('swiper-initialized') && !mobile && $('.swiper-wrapper', element).length > 0) {
                    var onDemandSlider = createOnDemandSlider(element);
                    onDemandSliders.push(onDemandSlider);
                } else if ($(element).hasClass('swiper-initialized') && !mobile && $('.swiper-wrapper', element).length > 0) {
                    //already initialized so continue
                } else {
                    destroySliders();
                }
            });
        }

        function destroySliders() {
            onDemandSliders.forEach(function (slider) {
                slider.destroy(true, true);
                $(slider.el).find('.swiper-wrapper').removeAttr('style');
                $(slider.el).find('.swiper-slide').removeAttr('style');
            });
            onDemandSliders = [];
        }

        function updateSliders() {
            var ww = $(window).outerWidth();
            var mobile = (ww < 960);

            if (mobile) {
                destroySliders();
            } else {
                initializeSliders();
            }
        }

        // Initialize sliders on page load
        initializeSliders();

        // Update sliders on window resize
        $(window).on('resize', function () {
            updateSliders();
        });
    }
});


